import { SET_SURVEYS, SET_SURVEY, SET_SURVEY_FILTERS } from "redux/reducers/surveys/surveysReducer"
import { PROYECT, api_get } from "services/api"
import { saveAs } from 'file-saver'
import axios from "axios"
import { getErrorBlob } from "helpers/extractError"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"

export const setSurveysFilters = (key = "", value) => {
  return { type: SET_SURVEY_FILTERS, payload: { key, value } }
}

export const getSurveys = (station, start, end) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/surveys?stations=${station?.id}&start=${start}&end=${end}`
  return async dispatch => {
    dispatch(startRequestComp('loadingSurveys'))
    await api_get(url).then(resp => {
      dispatch({ type: SET_SURVEYS, payload: resp })
      dispatch(stopRequestComp('loadingSurveys'))
    }).catch(err => {
      dispatch({ type: SET_SURVEYS, payload: [] })
      dispatch(setSnackbar(err, 'danger'))
      dispatch(stopRequestComp('loadingSurveys'))
    })
  }
}

export const getSurvey = (form) => {
  const {id, unit} = form
  const url = `${process.env.REACT_APP_URL}${PROYECT}/surveys/${id}/answers`
  return async dispatch => {
    dispatch(startRequestComp('loadingSurvey'))
    await api_get(url).then(resp => {
      dispatch({ type: SET_SURVEY, payload: {...resp, unit} })
      dispatch(stopRequestComp('loadingSurvey'))
    }).catch(err => {
      const error = err.message ? err.message : err
      dispatch(setSnackbar(error))
      dispatch(stopRequestComp('loadingSurvey'))
    })
  }
}


export const downloadSurvey = (startDate, endDate, station) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/surveys/answers-report?stations=${station?.id}&start=${startDate}&end=${endDate}`
  const cleanStation = station?.label?.split(' ').join('-') ?? ''
  const fileName = `Encuesta-${cleanStation}-${startDate}-${endDate}.xlsx`

  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user')
    dispatch(startRequestComp('loadingSurveysDownload'))
    try {
      const file = await axios({
        url,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      })
      saveAs(file.data, fileName)
      dispatch(setSnackbar('Descarga completada', 'success'))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingSurveysDownload'))
    }
  };
}
